export default {"src":"/_next/static/media/brown-cursor.02dca5c6.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};